import { useCallback } from "react";
import { UserDto } from "../types/user.types";
import { useRequestService } from "./service.base";
import { AuthProvider } from "../config/msal-config";

// Response when user requires Entra ID authentication
export interface EntraAuthResponse {
  useEntraAuth: true;
  provider: AuthProvider;
}

// Response for successful local authentication
export interface LocalAuthResponse extends UserDto {
  useEntraAuth?: false;
}

// Union type for all possible authentication responses
export type AuthResponse = EntraAuthResponse | LocalAuthResponse;

// Type guard to check if response requires Entra ID
export function isEntraAuthResponse(response: AuthResponse): response is EntraAuthResponse {
  return (response as EntraAuthResponse).useEntraAuth === true;
}

export function useAuthService() {
  const { httpGet, httpPost } = useRequestService();

  const login = useCallback(async function(email: string, password: string): Promise<AuthResponse | null> {
    return await httpPost("authenticate", {
        email,
        password
      })

  }, [httpPost]);

  const getAuthMethod = useCallback(async function(email: string): Promise<EntraAuthResponse | null> {
    return await httpGet(`authenticate/check-auth-method?email=${encodeURIComponent(email)}`);
  }, [httpGet]);

  return { login, getAuthMethod } as const
}
